module.exports = __webpack_public_path__ + "static/seo-stuff-d9fefbc7e07469722dec28500509d35b.png";